var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "v-store-news-list" },
    [
      _vm.newsList
        ? _vm._l(_vm.newsList.entries, function(news, key) {
            return _c("div", { key: key, staticClass: "p-news-outline" }, [
              _c(
                "div",
                { staticClass: "body" },
                [
                  _c("div", { staticClass: "header" }, [
                    _c("h5", { staticClass: "date" }, [
                      _vm._v(_vm._s(_vm.setDate(news.date)))
                    ]),
                    _vm._v(" "),
                    _c("ul", { staticClass: "category" }, [
                      news.shop.parentName
                        ? _c("li", [
                            _vm._v(
                              "\n              " +
                                _vm._s(news.shop.parentName) +
                                "\n            "
                            )
                          ])
                        : _vm._e(),
                      _vm._v(" "),
                      news.shop.name
                        ? _c("li", [
                            _vm._v(
                              "\n              " +
                                _vm._s(news.shop.name) +
                                "\n            "
                            )
                          ])
                        : _vm._e()
                    ])
                  ]),
                  _vm._v(" "),
                  news.url === ""
                    ? [
                        _c("div", { staticClass: "title" }, [
                          _c("a", {
                            attrs: { href: news.permalink },
                            domProps: {
                              innerHTML: _vm._s(_vm.h(news.overview))
                            }
                          })
                        ])
                      ]
                    : [
                        _c("div", { staticClass: "title" }, [
                          _c("a", {
                            attrs: { href: news.url, target: "_blank" },
                            domProps: {
                              innerHTML: _vm._s(_vm.h(news.overview))
                            }
                          })
                        ])
                      ]
                ],
                2
              ),
              _vm._v(" "),
              _c(
                "div",
                { staticClass: "image" },
                [
                  news.url === ""
                    ? [
                        _c("a", { attrs: { href: news.permalink } }, [
                          news.image
                            ? _c("img", { attrs: { src: news.image, alt: "" } })
                            : _c("img", {
                                attrs: {
                                  src: "/assets/img/news_noimage.png",
                                  alt: ""
                                }
                              })
                        ])
                      ]
                    : [
                        _c(
                          "a",
                          { attrs: { href: news.url, target: "_blank" } },
                          [
                            news.image
                              ? _c("img", {
                                  attrs: { src: news.image, alt: "" }
                                })
                              : _c("img", {
                                  attrs: {
                                    src: "/assets/img/news_noimage.png",
                                    alt: ""
                                  }
                                })
                          ]
                        )
                      ]
                ],
                2
              )
            ])
          })
        : [_c("div", [_vm._v("結果は0件です")])]
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }